export class DmsRequestContextChangedError extends Error {
  constructor() {
    super('DMS request context changed')
    this.name = 'DmsRequestContextChangedError'
  }
}

export const isDmsRequestContextChanged = (error: unknown): boolean =>
  error instanceof DmsRequestContextChangedError
